import { observable, action, runInAction, computed } from "mobx";
import { Dialog, MDialog } from "@weapp/ui";
import { getLabel } from "@weapp/utils";

import * as ForgetAPI from "../../../api/pc/forgetPassword";
import * as ForgetAPIOld from "../../../api/forgetPassword";
import { captchaType, forgetPasswordType, resetPasswordType } from "./type";
import { setTokenStorage, getTokenStorage, specialRegex, getSecurityStorage, setAccountStorage, mobileLocalReg, mobileReg } from "../../../utils";
import { publicUrl } from "../../../constants";

const { toast } = MDialog;
let timer: any = null

export class mForgetPasswordStore {

    @observable currentStep = 1;
    @observable hasSendVerificationCodeFlag = false;
    // 账户校验
    @observable accountCheck: any = null;
    // 提交验证码校验
    @observable sendCheck: any = null;
    // 密保启用状态
    @observable secrecyStatus: any = null; // D 关闭  E 启用
    // 注册账号类型
    @observable accountTypeIsPhone: boolean = true;

    @computed get stepsData() {
        return [
            { title: getLabel('125614', '输入账号') },
            { title: getLabel('93554', '找回密码的方式') },
            { title: getLabel('93529', '找回密码') }
        ]
    }
    @action init = () => { }
    // (待废弃 使用this.verifyAccount替代)
    validateAccount = async (obj: forgetPasswordType, callback: () => void) => {
        await ForgetAPI.checkAccount(obj).then((result: any) => {
            runInAction(() => {
                if (!result.data) {
                    toast({
                        content: getLabel('178406', '账号不存在，请您重新输入')
                    });
                    return
                } else {
                    // 发送手机/邮箱验证码
                    // todo
                    ForgetAPI.appSendValidCode(obj).then((result: any) => {
                        runInAction(() => {
                            if (result?.data?.errorMsg) {
                                const msg = result.data.errorMsg
                                toast({
                                    type: "fail",
                                    content: getLabel(msg.i18nId, msg.msg)
                                });
                                return;
                            }
                            toast({
                                type: 'success',
                                content: getLabel('93418', '验证码已经发送，请注意查收')
                            });
                            // console.log("已发送验证码...", result)
                            // 跳转
                            // window.location.href=`${publicUrl}/forgetPassword/step2`
                            // this.props.history.push(`${publicUrl}/forgetPassword/step2`)
                            sessionStorage.setItem('account', String(obj.account))
                            setTokenStorage(result.data)
                            this.hasSendVerificationCodeFlag = true
                            callback()
                        });
                    }).catch((error) => {
                        console.log(error);
                    });
                }
            });
        }).catch((error: any) => {
            console.log(error);
        });
    };

    // 重新发送短信验证码 (待废弃 后面统一走 this.sendCode)
    resend = (params: any) => {
        ForgetAPI.appSendValidCode(params).then((result: any) => {
            if (result?.data?.errorMsg) {
                const msg = result.data.errorMsg
                toast({
                    type: "fail",
                    content: getLabel(msg.i18nId, msg.msg)
                });
                return;
            }
            toast({
                type: 'success',
                content: getLabel('93418', '验证码已经发送，请注意查收')
            });
        }).catch((error) => {
            console.log(error);
        });
    }

    // 校验验证码 (待废弃 step2有用到)
    validatePhoneOrEmail = (obj: captchaType, cb?: Function) => {
        ForgetAPIOld.checkValidCode(obj).then((result: any) => {
            runInAction(() => {
                console.log("校验验证码...", result)
                if (result.actionMsg.code === 0) {
                    console.log('验证码正确...跳转')
                    // 跳转
                    window.location.href = `${publicUrl}/passport/password/do`
                    sessionStorage.setItem('account', String(obj.account))
                    cb && cb()
                } else {
                    console.log(result.actionMsg.message)
                    toast({
                        type: 'fail',
                        content: result.actionMsg.message
                    })
                }
            });
        }).catch((error) => {
            console.log(error);
        });
    }

    // 重置密码
    resetPassword = (obj: any) => {
        return new Promise((resolve, reject) => {
            const { account, code, password, passwordConfirm } = obj
            const userIdToken = getTokenStorage()
            let payload: any = { code, userIdToken, password: password, passwordCheck: passwordConfirm }
            let isMail = account.indexOf('@') !== -1
            let requestWay = ForgetAPI.changeByMobile
            if (isMail) {
                requestWay = ForgetAPI.appChangeByEmail
            }
            timer && clearTimeout(timer)

            requestWay(payload).then((result: any) => {
                if (result.code === 200) {
                    // toast({ type: "success", content: getLabel('65403', '重置密码成功，10s后跳回登录页面') });
                    // 延时跳转 3-4  重置密码成功，即将跳回登录页面
                    // toast({ type: "success", content: getLabel('95239', '重置密码成功，即将跳回登录页面'), delay: 0 });
                    // timer = setTimeout(() => window.location.href = '/', 3000)
                    resolve(result)
                } else {
                    toast({ type: "fail", content: result.data?.errorMsg?.alreadyTranslate ? result.data?.errorMsg.msg : getLabel(result.data?.errorMsg.i18nId, result.data?.errorMsg.msg) });
                    reject(result)
                }
            }).catch((error) => {
                console.log(error);
            });
        })
    }
    handleI18NFailTip = (response: any, reject: any) => {
        let info = response.data && response.data.errorMsg || {}
        toast({ type: 'fail', content: getLabel(info.i18nId, info.msg) })
        reject(info)
    }
    // 验证手机号/邮箱
    verifyAccount = async (account: string, methods: any, areacode?: string) => {
        return new Promise((resolve, reject) => {
            if (!account) {
                runInAction(() => { this.accountCheck = { type: 'error', content: getLabel('93481', '账号不能为空'), checked: true } })
                return reject(this.accountCheck)
            }

            let accountChecked = true;
            const emailReg = /^([-_A-Za-z0-9.]+)@([_A-Za-z0-9]+\.)+[A-Za-z0-9]{2,3}$/;
            let checkEmail = emailReg.test(account);
            let errorMessage = getLabel('93556', '格式不正确！请重新输入');

            // 只检查邮箱
            if (methods === '0') {
                accountChecked = checkEmail;
                errorMessage = getLabel('93383', '邮箱格式不正确')
            }
            if (methods === '1') {
                if (areacode === '+86') {//国内电话号校验
                    accountChecked = mobileLocalReg.test(account);
                } else {//国外电话号校验
                    accountChecked = mobileReg.test(account);
                }
                errorMessage = getLabel('179915', "请填写格式正确的手机号")
            }
            if (!accountChecked) {
                runInAction(() => { this.accountCheck = { type: 'error', content: errorMessage, checked: true } })
                return reject(this.accountCheck)
            }
            ForgetAPI.checkAccount({ account, areacode }).then((result: any) => {
                runInAction(() => {
                    if (!result.data) {
                        this.accountCheck = {
                            type: 'error',
                            content: getLabel('178406', '账号不存在，请您重新输入'),
                            checked: true
                        }
                        return reject(result)
                    }
                    // 校验成功保存账号到本地 用于刷新
                    localStorage.setItem('e_forgetPwd_account', account)
                    if (areacode) {
                        localStorage.setItem('e_forgetPwd_areaCode', areacode)
                    }
                    this.accountCheck = { checked: true }
                    resolve(result)
                })
            }).catch((error: any) => {
                reject(error)
            })
        })
    }
    // 发送邮箱/短信验证码
    sendCode = (account: string, areaCode?: string) => {
        ForgetAPI.appSendValidCode({ account, areaCode }).then((result: any) => {
            if (result.code === 200) {
                setTokenStorage(result.data)
                return toast({
                    type: 'success',
                    content: getLabel('93418', '验证码已经发送，请注意查收')
                })
            }
            if (result?.data?.errorMsg) {
                return toast({
                    type: "fail",
                    content: getLabel(result.data.errorMsg.i18nId, result.data.errorMsg.msg)
                })
            }
        }).catch((error) => {
            console.log(error);
        });
    }
    /**
     * 查询用户是否开启密保找回
     * @param account
     */
    @action qrySecrecyStatus = (account: string) => {
        return new Promise(async (resolve, reject) => {
            try {
                let response = await ForgetAPI.querySecrecyStatus(account)
                if (response.data && response.data.errorMsg) {
                    return this.handleI18NFailTip(response, reject)
                }
                let { result } = response.data || {}
                runInAction(() => {
                    this.secrecyStatus = result || 'D'
                })
                resolve(result || 'D')
            } catch (e) { reject(e) }
        })
    }
    /**
   * 获取邮箱修改密码token
   * @param key
   */
    @action
    getTokenByEmail = (key: string) => {
        return new Promise((resolve, reject) => {
            ForgetAPI.getTokenByEmail({ key }).then((result: any) => {
                runInAction(() => {
                    if (result.data) {
                        if (result.data.errorMsg) {
                            return toast({
                                content: getLabel(result.data.errorMsg.i18nId, result.data.errorMsg.msg)
                            })
                        }
                        const { user, token, customTenantKey } = result.data;
                        if (customTenantKey) {
                            sessionStorage.setItem('email_psw_customTenantKey', customTenantKey);
                        }
                        setTokenStorage(token)
                        localStorage.setItem('e_forgetPwd_account', user.email || user.account);
                        resolve(user.email || user.account)
                    }
                })
            }).catch((error: any) => {
                console.log(error)
                reject(error)
            })
        })
    }
    // 查询密保问题
    @action qryUserSecrecy = (account: string) => {
        return new Promise(async (resolve, reject) => {
            try {
                let response = await ForgetAPI.qryUserSecrecy(account)
                if (response.data && response.data.errorMsg) {
                    return this.handleI18NFailTip(response, reject)
                }
                resolve(response.data)
            } catch (e) { reject(e) }
        })
    }
    // 校验密保问题
    @action validSecrecy = (account: string, data: any) => {
        return new Promise(async (resolve, reject) => {
            let payload = {
                params: [data]
            }
            try {
                let response = await ForgetAPI.validSecrecy(account, payload)
                if (response.code !== 200) {
                    toast({
                        type: 'fail',
                        content: response.data?.errorMsg ?
                            getLabel(response.data?.errorMsg.i18nId, response.data?.errorMsg.msg) :
                            response.msg
                    })
                    return reject(response)
                }
                resolve(response.data)
            } catch (e) {
                reject(e)
            }
        })
    }
    /**
     * 密保验证后确认修改密码
     * @param password
     * @param passwordConfirm
     */
    @action
    confirmChangePwdBySecrecy = (password: string, passwordConfirm: string) => {
        return new Promise((resolve, reject) => {
            const securityToken = getSecurityStorage('e_security_token')
            let payload: any = { password, passwordCheck: passwordConfirm, userIdToken: securityToken }
            ForgetAPI.changeBySecrecy(payload).then((result: any) => {
                runInAction(() => {
                    if (result.data && result.code === 200) {
                        if (result.data.errorMsg) return this.handleI18NFailTip(result, reject);
                        return resolve(result)
                    }
                    if (result.code === 40014) {
                        // 密保验证过期 重新回到验证密保页面
                        toast({ type: 'fail', content: result.msg })
                        return reject('needSecurity')
                    }
                    reject(result)
                })
            }).catch((error: any) => {
                reject(error)
            })
        })
    }

    @action
    resetAccountCheck = () => {
        this.accountCheck = null;
    }
}

const instance = new mForgetPasswordStore();
export type mForgetPasswordStoreType = Pick<mForgetPasswordStore, keyof mForgetPasswordStore>;

export default instance;
